/*
 * Filename: field-uiType.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const FieldUIType = types.model({
    FieldUIType: types.optional(types.frozen(), {}),
    selectUITypeValue: types.optional(types.frozen(), {})
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({

    deleteUITypeValueSource(objectName: string) {
        let existingUITypeObject = { ...self.FieldUIType };
        delete existingUITypeObject[objectName];
        self.FieldUIType = existingUITypeObject;

    },

    /**
     * Sets the FieldUIType
     * @function addUITypeSource
     * @param {string} objectName
     * @param {{showSelectOption : boolean, selectedValue : string, showFilePicker : boolean}} uiTypeSource
     */
    addUITypeSource(objectName: string, uiTypeSource: any) {
        let fieldUITypeValueSource = { ...self.FieldUIType };
        if (self.FieldUIType.hasOwnProperty(objectName)) {
            delete fieldUITypeValueSource[objectName];
            self.FieldUIType = { ...fieldUITypeValueSource, [objectName]: uiTypeSource };
        }else{
            if(uiTypeSource.type === 'polymorphic'){
                fieldUITypeValueSource = {[objectName]:{"type":"polymorphic"}};
                self.FieldUIType = fieldUITypeValueSource;
            }else{
                fieldUITypeValueSource = { ...fieldUITypeValueSource, [objectName]: uiTypeSource };
                self.FieldUIType = fieldUITypeValueSource;
            }
        }
    },
    setSelectedUITypeValue(objectName:string){
        if(self.FieldUIType.hasOwnProperty(objectName)){
            const value = self.FieldUIType[objectName];
            self.selectUITypeValue = value;
        } else{
            self.selectUITypeValue = {}
        }
    },
    setDeployedUITypeData(uiTypeValues:any){
        self.FieldUIType = uiTypeValues;
    }
}));
